import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './JournalHighlights.css';
import { JournalHighlightsItem } from './components/JournalHighlightsItem';
import { JournalHighlightsSliderDesktop } from './components/JournalHighlightsSliderDesktop';
import { JournalHighlightsSliderMobile } from './components/JournalHighlightsSliderMobile';
import { IJournalHighlightsItem } from '../../../common/types/journal';

interface IJournalHighlightsProps {
  items: IJournalHighlightsItem[];
  onLinkClick(e: React.SyntheticEvent<HTMLAnchorElement>): void;
}

export function JournalHighlightsSlider({ items, onLinkClick }: IJournalHighlightsProps) {
  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';
  const Wrapper = isPhone ? JournalHighlightsSliderMobile : JournalHighlightsSliderDesktop;

  return (
    <Wrapper>
      {items.map(({ url, title, img, description }) => (
        <JournalHighlightsItem
          key={title}
          className={styles['card']}
          description={description}
          img={img}
          title={title}
          url={url}
          onClick={onLinkClick}
        />
      ))}
    </Wrapper>
  );
}
